export default __webpack_public_path__ + "static/media/upload-demo.262569b9.jpg";